import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function NotFoundPage() {
  return <>
    <Navbar />
    <main className="albumPageContent">
      <h1>Pagina nu există</h1>
      <p>Adresa căutată nu corespunde unui proiect sau unei pagini disponibile.</p>
      <Link to="/portfolio">Înapoi la portofoliu</Link>
    </main>
    <Footer />
  </>;
}
